import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { XnCarouselComponent } from './xn-carousel.component';
import {GalleriaModule} from 'primeng/galleria';


@NgModule({
  declarations: [
    XnCarouselComponent
  ],
  imports: [
    CommonModule,
    GalleriaModule
  ],
  exports: [
    XnCarouselComponent,
  ]
})
export class XnCarouselModule { }
